import { InjectionToken, ElementRef } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';

export interface KeyboardEventsConfig {
  target?: 'document' | 'host' | ElementRef<HTMLElement>;
  eventType?: 'keydown' | 'keyup' | 'keypress';
}

export const KEYBOARD_EVENTS = new InjectionToken<Observable<KeyboardEvent>>('Stream of keyboard events', {
  providedIn: 'root',
  factory: () => fromEvent<KeyboardEvent>(document, 'keydown'),
});
